import { useSelector } from "react-redux";

// Org-level license tier, not the current user's own role — reliable
// regardless of whether the logged-in user happens to be a doctor, nurse,
// or admin. Same signal useHasPermission.js already relies on.
const useIsEnterpriseOrg = () => {
  const licenseType = useSelector((state) => state?.license?.package?.license);
  return licenseType === "ENTERPRISE";
};

export default useIsEnterpriseOrg;
